import React from 'react'

import { Reorder, useDragControls } from 'framer-motion'

import { useMediaQuery } from 'hooks'

import ImageCard from './ImageCard'
import { PlusIcon } from 'images'

const CarouselImageReorderItem = ({
  image,
  index,
  getStatus,
  selectedImageId,
  setSelectedImageId,
  onOpenExpandedImage,
  useDragHandle,
}) => {
  const dragControls = useDragControls()

  return (
    <Reorder.Item
      as="div"
      value={image}
      style={{ position: 'relative' }}
      className="image-list__reorder-item"
      {...(useDragHandle ? { dragListener: false, dragControls } : {})}
    >
      {useDragHandle ? (
        <button
          type="button"
          className="image-card-drag-handle"
          aria-label="Reorder carousel image"
          onPointerDown={(event) => {
            event.stopPropagation()
            dragControls.start(event)
          }}
        >
          <span className="image-card-drag-handle__grip" aria-hidden>
            <span />
            <span />
            <span />
          </span>
        </button>
      ) : null}
      <ImageCard
        index={index}
        media={image.media}
        status={getStatus(image)}
        isSelected={selectedImageId === image.id}
        handleSelect={() => setSelectedImageId(image.id)}
        handleDoubleClick={() => onOpenExpandedImage?.(image.id)}
      />
    </Reorder.Item>
  )
}

const ImageList = (props) => {
  const { images, setImages, selectedImageId, setSelectedImageId, addCard, onOpenExpandedImage, readonly } = props

  const useDragHandle = useMediaQuery('(max-width: 991px)')

  const getStatus = (image) => {
    if (image.media === null && image.headline === '' && image.description === '' && image.url === '') {
      return 'missing'
    } else if (image.media && image.headline && image.description && image.url) {
      return 'ready'
    } else {
      return 'partial'
    }
  }

  // return
  return (
    <div className='image-list-container'>
      {!readonly ? (
        <Reorder.Group
          as="div"
          values={images}
          axis="x"
          className="image-list"
          onReorder={setImages}
        >
          {images?.map((image, index) => (
            <CarouselImageReorderItem
              key={image.id}
              image={image}
              index={index}
              getStatus={getStatus}
              selectedImageId={selectedImageId}
              setSelectedImageId={setSelectedImageId}
              onOpenExpandedImage={onOpenExpandedImage}
              useDragHandle={useDragHandle}
            />
          ))}
        </Reorder.Group>
      ) : (
        <div className='image-list'>
          {images?.map((image, index) => (
            <ImageCard
              key={image.id}
              index={index}
              media={image.media}
              status={getStatus(image)}
              isSelected={selectedImageId === image.id}
              handleSelect={() => setSelectedImageId(image.id)}
              handleDoubleClick={() => onOpenExpandedImage?.(image.id)}
            />
          ))}
        </div>
      )}

      {images.length < 10 && !readonly && (
        <div className='image-list__add-button' onClick={() => addCard(1)}>
          <PlusIcon width={22} height={22} />
        </div>
      )}
    </div>
  )
}

export default ImageList